<template>
  <div class="helpCenter">
    <div class="main">
      <Row class="header">
        <i-col span="12">
          <h2 class="title">
            <b>{{$t('title.w11')}}</b>
            <small>Help center</small>
          </h2>
          <h3 class="t3">{{$t('other.w38')}}</h3>
          <!-- <div class="input-search">
            <Input  search enter-button="搜索" :placeholder="$t('pl.p22')" type="text"/>
            <i></i>
          </div> -->
        </i-col>
      </Row>
      <div class="content" v-for="(v, i) in arr1" :key="i">
        <h3 class="t">{{v.CategoryName}}</h3>
        <Row class="specific">
          <template v-for="(m, n) in v.ItemList">
            <i-col
              :key='n'
              span="8"
              class="list"
              :class="{'active': isActiveItem(i, n) && activeItem[i][Math.ceil((n + 1) / 3) - 1].item == n % 3}"
              @click.native="getHelpCenterContent(m, n, i)">
              <img :class="{'flip': isActiveItem(i, n) && activeItem[i][Math.ceil((n + 1) / 3) - 1].item == n % 3}" src="../../assets/help/Rectangle_right@2x.png" alt="">
              <p>{{m.ItemName}}</p>
            </i-col>
            <i-col
              span="24"
              class="hide"
              v-if="((n+1)%3==0 || (n+1)==v.ItemList.length) && isActiveItem(i, n) && activeItem[i][Math.ceil((n + 1) / 3) - 1].item !== undefined"
              :key='m.ItemId'>
              <div v-if="activeItem[i][Math.ceil((n + 1) / 3) - 1].link"><router-link :to="{name:'helpdetail',params:{id:activeItem[i][Math.ceil((n + 1) / 3) - 1].id}}">点击查看</router-link>{{activeItem[i][Math.ceil((n + 1) / 3) - 1].title}}</div>
              <div v-else v-html="activeItem[i][Math.ceil((n + 1) / 3) - 1].text"></div>
            </i-col>
          </template>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      arr1:[],
      activeItem: {},
      activeIdx:[] //当前展开ID
    }
  },
  created(){
    this.getData()
  },
  methods:{
    // 获取详细
    getHelpCenterContent (item, index, n) {
      // 当前所对应的内容框
      let contentIdx=Math.ceil((index + 1) / 3) - 1;
      // 判断当前内容是否已展开，已展开则关闭
      if(this.activeIdx[n]==index){
        this.activeIdx[n]=undefined
        return this.$set(this.activeItem[n], contentIdx, undefined)
      }
      this.activeIdx[n]=index
      // 如果当前类目是第一次点击，初始化为数组
      if (!this.activeItem[n]) {
        this.$set(this.activeItem, n, [])
      }
      // 记录每个类目下的每一行，将其当做一个对象，item记录当前所点击的当前行的索引位置，用作确定active，text用来记录当前行所需要展示的文字
      this.$set(this.activeItem[n], contentIdx, {
        item: index % 3,
        text: '',
        link: item.IsLink,
        title:item.ItemName,
        id:item.ItemId
      })
      // 发送请求
      this.$axios.get('/Member/RZJInfoCenter/HelpCenterContent', {
        params: {
          itemId: item.ItemId
        }
      }).then(res => {
        // 填入当前行的文字
        this.$set(this.activeItem[n][contentIdx], 'text', res.Content)
      })
    },
    // activeItem 内的元素是否存在
    isActiveItem (i, n) {
      return this.activeItem[i] && this.activeItem[i][Math.ceil((n + 1) / 3) - 1]
    },
    // 请求所有类目及子类目
    getData(){
      this.$axios.get('/Member/RZJInfoCenter/HelpCenterList')
      .then(res => {
        this.arr1 = res
      })
    }
  }
};
</script>

<style lang="less" scoped>
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
.helpCenter {
  margin-bottom: 70px;
  .main {
    width: 1200px;
    margin: 0 auto;
    font-size: 14px;
    .header {
      padding-left: 23px;
      margin: 60px 0 20px 0;
      height: 338px;
      background: url("../../assets/help/Group38@2x.png") no-repeat right;
      background-size: 514px 338px;
      .title {
        margin-top: 20px;
        b {
          display: block;
          font-size: 48px;
          font-weight: 500;
          color: #232325;
        }
        small {
          display: block;
          color: #b3b3b6;
          text-transform: uppercase;
        }
      }
      .t3 {
        margin: 30px 0 20px 0;
        font-size: 24px;
        letter-spacing:1px;
        font-weight: 500;
         color: #232325;
      }
      .input-search{
        width: 509px;
        position: relative;
        /deep/.ivu-input-wrapper{
          border-radius:8px;
          border:1px solid rgba(221,221,221,1);
          .ivu-input{
            padding-left: 30px;
          }
        }
        i{
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url("../../assets/help/pic_icosearch@2x.png") no-repeat;
          background-size: cover;
          position: absolute;
          top: 14px;
          left: 8px;
          z-index: 5;
        }
      }
    }
    .content{
      margin-top: 30px;
      .t{
        font-size: 18px;
        color: #333333;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .specific{
        padding: 15px 20px;
        min-height: 200px;
        border-radius:4px;
        background: #fff;
        font-size: 14px;
        color: #666666;
        .list{
          cursor: pointer;
          height: 50px;
          display: flex;
          align-items: center;
          img{
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-right: 15px;
          }
          .flip{
            transform: rotate(90deg);
            transition-delay: 5ms;
            transition-duration: 0.3s;
          }
        }
        .active{
          color: #3768C2;
        }
        .hide{
          padding: 20px 20px 15px;
          background: #F2F4F9;
          margin: 15px 0;
          overflow: hidden;
          p{
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}

</style>